// extracted by mini-css-extract-plugin
export default {"ThumbsList":"GCgn5AVR","active":"W9c7fk1r","video":"C5Rkj26q","activeVideo":"l0UCwFvI"};